import { render, staticRenderFns } from "./othersEmployeeConfig.vue?vue&type=template&id=70d64078&"
import script from "./othersEmployeeConfig.vue?vue&type=script&lang=js&"
export * from "./othersEmployeeConfig.vue?vue&type=script&lang=js&"
import style0 from "./othersEmployeeConfig.vue?vue&type=style&index=0&id=70d64078&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports